import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
  inject,
  EventEmitter,
  Output,
} from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { CareplusNewCustomer } from "src/models/careplus-new-customer";
import { Router } from "@angular/router";
import { CareplusAgencyService } from "src/services/careplus-agency-service";

@Component({
  selector: "app-careplus-batch-customers",
  templateUrl: "./careplus-batch-customers.component.html",
  styleUrls: ["./careplus-batch-customers.component.css"],
})
export class CareplusBatchCustomersComponent implements OnInit {
  private _router = inject(Router);
  private _agencyService = inject(CareplusAgencyService);
  @Input() customers: CareplusNewCustomer[] = [];
  @Input() batchId: number | null = null;
  @Input() loadFromApi: boolean = false;
  @Input() isFromCheckout: boolean = false;
  isLoading = false;
  dataSource = new MatTableDataSource<CareplusNewCustomer>([]);
  @Output() batchDetails = new EventEmitter<any>();
  displayedColumns: string[] = [
    "id",
    "firstName",
    "lastName",
    "phoneNumber",
    "gender",
    "dateOfBirth",
    "dependentCounts",
    "email",
    "amount",
  ];

  ngOnInit() {
    this.initializeData();
  }

  initializeData() {
    if (this.loadFromApi && this.batchId) {
      this.fetchBatchCustomers();
      return;
    }

    this.dataSource.data = this.customers || [];
  }

  fetchBatchCustomers() {
    if (!this.batchId) {
      return;
    }

    this.isLoading = true;

    this._agencyService.getBatchDetail(this.batchId).subscribe({
      next: (res) => {
        this.dataSource.data = res?.customers || [];
        this.batchDetails.emit(res);
        this.isLoading = false;
      },
      error: () => {
        this.dataSource.data = [];
        this.isLoading = false;
      },
    });
  }

  openCustomer(row: CareplusNewCustomer) {
    if (this.isFromCheckout) {
      this._router.navigate(["/careplus/careplus-add-customers/" + row.id], {
        state: { fromCheckout: true },
      });
    } else {
      this._router.navigate(["/careplus/careplus-add-customers/" + row.id], {
        state: { isAdmin: true },
      });
    }
  }
}
